const doc = [({"en":({"js":({"admin":({"order_lines":({"table":({"image":"Image"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;